export default {
  include(state) {
    return state.include;
  },
  axiosPing(state) {
    return state.axiosPing;
  },
  loading(state) {
    return state.loading;
  },
  platformInfo(state) {
    return state.platformInfo;
  },
  userInfo(state) {
    return state.userInfo;
  },
  usableMoney(state) {
    return state.usableMoney;
  },
  backFlag(state) {
    return state.backFlag;
  },
  language(state) {
    return state.language;
  },
  token(state) {
    return state.token;
  }
};
